import { SVGProps } from "react"
const ScanComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={26}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M26.14 13.554H.968a.968.968 0 0 1 0-1.937H26.14a.968.968 0 0 1 0 1.937ZM23.236 25.17H17.9a.968.968 0 1 1 0-1.936h5.337a.967.967 0 0 0 .967-.968v-4.84a.968.968 0 1 1 1.937 0v4.84a2.908 2.908 0 0 1-2.904 2.904Zm-13.848 0H3.873a2.908 2.908 0 0 1-2.905-2.904v-4.84a.968.968 0 1 1 1.936 0v4.84c0 .534.435.968.969.968h5.515a.968.968 0 1 1 0 1.936ZM1.937 8.713a.969.969 0 0 1-.969-.968v-4.84A2.907 2.907 0 0 1 3.873 0h5.515a.969.969 0 1 1 0 1.936H3.873a.97.97 0 0 0-.969.968v4.84a.968.968 0 0 1-.967.97Zm23.235 0a.969.969 0 0 1-.969-.968v-4.84a.968.968 0 0 0-.967-.97H17.9a.968.968 0 1 1 0-1.935h5.337c1.6 0 2.904 1.303 2.904 2.904v4.84a.968.968 0 0 1-.968.97Z"
    />
  </svg>
)
export default ScanComponent